import { InjectionToken } from '@angular/core';

export * from './lib/directives';
export * from './lib/services';
export * from './lib/guards/auth.guard';
export * from './lib/functions';
export * from './lib/pipes';
export * from './lib/components/prompt-dialog/PromptDialog.component';
export * from './lib/components/confirm-dialog/confirm-dialog.component';
export * from './lib/components/video-player/videoPlayer';

export * from './lib/components/emoji/emojiComponent';
export * from './lib/components/import/import.component';
export * from './lib/components/qrcode/qrcode';

export const ENVIRONMENT = new InjectionToken('environment');
export * from './lib/components/message/message.component';

export * from './lib/components/code/code.component';
